import { t } from '@lingui/core/macro';
import { BackButton } from 'components/BackButton/BackButton';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { InnerLayout } from 'components/Layout/InnerLayout/InnerLayout';
import { SideNavigation } from 'components/Navigation/SideNavigation';
import { useOffers } from 'components/Signup/hooks/useOffers';
import { useRouterApplicationId } from 'components/Signup/hooks/useRouterApplicationId';
import { ProductOffers } from 'components/Signup/ProductOffers/ProductOffers';
import { StepValidator } from 'components/Signup/StepValidator/StepValidator';
import { useAmplitude } from 'hooks/useAmplitude';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

import styles from './productOffers.module.css';

export const ProductOffersPage = () => {
  const applicationId = useRouterApplicationId();
  const { trackEvent } = useAmplitude();

  const handleProductOffersBackTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.backCTAClicked);
  };

  const { isSecurityCheckRequired, signupError, isRefetchingOffers } =
    useOffers({ getOffersEnabled: false });

  const showBackButton =
    !isSecurityCheckRequired || signupError || isRefetchingOffers;

  return (
    <BaseLayout
      pageTitle={t`New Offers | Introducer Portal`}
      className={styles.applicationLayout}
      contentPadding={false}
    >
      <SideNavigation />

      <StepValidator>
        <InnerLayout contentClassName={styles.mainContent} hasSidebar>
          {showBackButton && (
            <BackButton
              href={PATH_NAMES.newApplicationStep1({ applicationId })}
              onClick={handleProductOffersBackTracking}
            />
          )}
          <ProductOffers />
        </InnerLayout>
      </StepValidator>
    </BaseLayout>
  );
};
